
import { defineComponent, PropType } from "vue";

import Box from "./BoxComp.vue";
import Button from "./ButtonComp.vue";
import Chronometer from "./ChronometerComp.vue";

import ITask from "@/interfaces/ITask";
import { useStore } from "@/store";
import { DELETE_TASK } from "@/store/actions-types";

export default defineComponent({
  name: "TaskComp",
  emits: ["onTriggeredTask"],
  props: {
    task: {
      type: Object as PropType<ITask>,
      required: true,
    },
  },
  setup(props, context) {
    const store = useStore();

    const triggeredTask = (): void => {
      context.emit("onTriggeredTask");
    };
    const removeTask = (taskId: string) => {
      store.dispatch(DELETE_TASK, taskId);
    };

    return {
      triggeredTask,
      removeTask,
    };
  },
  components: {
    Chronometer,
    Box,
    Button,
  },
});
